import { SEGMENT_ANONYMOUS_ID_COOKIE } from "@/constants/cookies";
import { readCookie } from "@/utils/cookies";
import { getDetailsByPathname } from "@/utils/getDetailsByPathname";
import { currentTheme } from "@/utils/theming";

/**
 * Pseudo–"Loaded a Page" fields (same shape as former dataLayer push).
 * Used for first-party gtag('event','page_view') params (mimic Segment→GTM).
 *
 * @see https://nutrafol.atlassian.net/browse/NT2-30510
 */
export type LoadedAPagePayload = {
  OnetrustActiveGroups: string | null;
  OptanonActiveGroups: string | null;
  nutrafolBrandTag: "men" | "master";
  path: string;
  referrer: string;
  search: string;
  title: string;
  url: string;
  business_line: string;
  page_category: string | null;
  page_type: string | null;
  page_referrer: string;
  page_product_line: string | null;
  page_detail: string | null;
  page_template: string;
  page_intent: string;
  userAgent: string;
  name: string;
  userId: string | null;
  segmentAnonymousId: string | null;
};

export function buildLoadedAPagePayload(): LoadedAPagePayload {
  const pathname = window.location.pathname;
  const { page_type, page_category, page_details, product_line, business_line } =
    getDetailsByPathname();

  const name = document.title?.split(" | ")[0] || "";
  const otGroups =
    typeof window.OnetrustActiveGroups === "string" ? window.OnetrustActiveGroups : "";
  const optanonGroups =
    typeof window.OptanonActiveGroups === "string" ? window.OptanonActiveGroups : otGroups;

  return {
    OnetrustActiveGroups: otGroups || null,
    OptanonActiveGroups: optanonGroups || null,
    nutrafolBrandTag: currentTheme(pathname) === "men" ? "men" : "master",
    path: pathname,
    referrer: document.referrer || "",
    search: window.location.search || "",
    title: document.title || "",
    url: window.location.href,
    business_line: typeof business_line === "string" ? business_line.toLowerCase() : "hair",
    page_category: page_category ?? null,
    page_type: page_type ?? null,
    page_referrer: document.referrer || "",
    page_product_line: product_line ?? null,
    page_detail: page_details ?? null,
    page_template: "default",
    page_intent: "browse",
    userAgent: navigator.userAgent,
    name,
    userId: null,
    segmentAnonymousId: readCookie(SEGMENT_ANONYMOUS_ID_COOKIE),
  };
}
